import React from 'react';
import { useNavigate } from 'react-router-dom';
import { House, Strategy, PlusCircle, ShoppingCart, User } from 'phosphor-react';
import './SFooterNav.css';

export type NavItem = 'home' | 'my-game' | 'add' | 'shop' | 'profile';

interface SFooterNavProps {
  activeItem?: NavItem;
  onItemClick?: (item: NavItem) => void;
}

export const SFooterNav: React.FC<SFooterNavProps> = ({
  activeItem = 'home',
  onItemClick
}) => {
  const navigate = useNavigate();

  const navItems = [
    { id: 'home' as NavItem, icon: House, label: 'Home' },
    { id: 'my-game' as NavItem, icon: Strategy, label: 'My Game' },
    { id: 'add' as NavItem, icon: PlusCircle, label: '', isCenter: true },
    { id: 'shop' as NavItem, icon: ShoppingCart, label: 'Shop' },
    { id: 'profile' as NavItem, icon: User, label: 'Profile' },
  ];

  const handleClick = (item: NavItem) => {
    // Handle navigation for different items
    switch (item) {
      case 'home':
        navigate('/home');
        break;
      case 'my-game':
        navigate('/my-game');
        break;
      case 'add':
        navigate('/booking-type');
        break;
      case 'shop':
        navigate('/shop');
        break;
      case 'profile':
        navigate('/profile');
        break;
      default:
        // Stay on current page for unknown items
        break;
    }

    // Still call onItemClick if provided for backward compatibility
    if (onItemClick) {
      onItemClick(item);
    }
  };

  return (
    <>
      <nav className="s-footer-nav">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeItem === item.id;
          const isCenterButton = item.isCenter;

          return (
            <button
              key={item.id}
              className={`s-footer-nav-item ${isActive ? 'active' : ''} ${isCenterButton ? 'center' : ''}`}
              onClick={() => handleClick(item.id)}
              aria-label={item.label || item.id}
            >
              {isCenterButton ? (
                <div className="s-footer-nav-center-button">
                  <Icon size={24} weight="regular" />
                </div>
              ) : (
                <>
                  <Icon size={24} weight={isActive ? 'fill' : 'regular'} />
                  {item.label && <span className="s-footer-nav-label">{item.label}</span>}
                </>
              )}
            </button>
          );
        })}
      </nav>
      <div className="s-footer-nav-bottom">
        <div className="s-footer-nav-indicator" />
      </div>
    </>
  );
};
